import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const FilterBar = ({
  categories,
  priceRanges,
  frequencies,
  selectedCategory,
  setSelectedCategory,
  priceRange,
  setPriceRange,
  frequency,
  setFrequency
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const clearAllFilters = () => {
    setSelectedCategory('all');
    setPriceRange('all');
    setFrequency('all');
  };

  const hasActiveFilters = selectedCategory !== 'all' || priceRange !== 'all' || frequency !== 'all';

  return (
    <div className="bg-surface rounded-lg shadow-medium p-6 mb-8 sticky top-20 z-50">
      {/* Mobile Filter Toggle */}
      <div className="md:hidden">
        <button
          onClick={() => setIsFilterOpen(!isFilterOpen)}
          className="w-full flex items-center justify-between text-text-primary font-medium"
        >
          <span className="flex items-center space-x-2">
            <Icon name="Filter" size={20} />
            <span>Filtros</span>
            {hasActiveFilters && (
              <span className="bg-primary text-white text-xs px-2 py-1 rounded-full">
                Activos
              </span>
            )}
          </span>
          <Icon name={isFilterOpen ? "ChevronUp" : "ChevronDown"} size={20} />
        </button>
      </div>

      {/* Filter Content */}
      <div className={`${isFilterOpen ? 'block' : 'hidden'} md:block mt-4 md:mt-0`}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {/* Category Filter */}
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Categoría
            </label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
            >
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>

          {/* Price Range Filter */}
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Rango de Precio
            </label>
            <select
              value={priceRange}
              onChange={(e) => setPriceRange(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
            >
              {priceRanges.map((range) => (
                <option key={range.id} value={range.id}>
                  {range.label}
                </option>
              ))}
            </select>
          </div>

          {/* Frequency Filter */}
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Frecuencia
            </label>
            <select
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
            >
              {frequencies.map((freq) => (
                <option key={freq.id} value={freq.id}>
                  {freq.label}
                </option>
              ))}
            </select>
          </div>

          {/* Clear Filters */}
          <div className="flex items-end">
            <button
              onClick={clearAllFilters}
              disabled={!hasActiveFilters}
              className={`w-full px-4 py-2 rounded-lg font-medium nav-transition ${
                hasActiveFilters
                  ? 'bg-secondary text-white hover:bg-secondary/90' :'bg-border text-text-secondary cursor-not-allowed'
              }`}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>

        {/* Active Filters Display */}
        {hasActiveFilters && (
          <div className="mt-4 pt-4 border-t border-border">
            <div className="flex flex-wrap gap-2">
              <span className="text-sm text-text-secondary">Filtros activos:</span>
              
              {selectedCategory !== 'all' && (
                <span className="inline-flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm">
                  <span>{categories.find(c => c.id === selectedCategory)?.label}</span>
                  <button
                    onClick={() => setSelectedCategory('all')}
                    className="hover:text-primary/70"
                  >
                    <Icon name="X" size={14} />
                  </button>
                </span>
              )}
              
              {priceRange !== 'all' && (
                <span className="inline-flex items-center space-x-1 bg-accent/10 text-accent px-3 py-1 rounded-full text-sm">
                  <span>{priceRanges.find(p => p.id === priceRange)?.label}</span>
                  <button
                    onClick={() => setPriceRange('all')}
                    className="hover:text-accent/70"
                  >
                    <Icon name="X" size={14} />
                  </button>
                </span>
              )}
              
              {frequency !== 'all' && (
                <span className="inline-flex items-center space-x-1 bg-success/10 text-success px-3 py-1 rounded-full text-sm">
                  <span>{frequencies.find(f => f.id === frequency)?.label}</span>
                  <button
                    onClick={() => setFrequency('all')}
                    className="hover:text-success/70"
                  >
                    <Icon name="X" size={14} />
                  </button>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterBar;